export default __webpack_public_path__ + "static/media/adtoi-logo.b223243b.jpg";